import AvailableList from './AvailableList';
import TravelStageList from './TravelStageList';
import OpenTripsList from './OpenTripsList';
import CandidateModal from './Candidates';
import FilterModal from './Filters';
import AttendanceActions from './Attendance/Actions';
import { RefusalPlateInfo } from './Refusals/Actions';
import OtherAttendance from './Attendance/OtherAttendance';
import WagonMap from './Candidates/WagonMap';
import { CandidateLink, CandidatePlate } from './Candidates/PlateDetails';
import TransitTime, {
  TransitTimeProvider,
} from 'v3/components/ControlTower/TravelResources/TransitTime';
import Occurrences from 'v3/components/ControlTower/TravelResources/Occurrences';
import { KanbanDriverContact } from 'v3/components/ControlTower/TravelResources/DriverContact';

// Recursos compartilhados das linhas; progresso consultado em lote por página.
export const rowIntegrations = {
  occurrences: Occurrences,
  transitTime: TransitTime,
  transitTimeProvider: TransitTimeProvider,
  driverContact: KanbanDriverContact,
  candidateMap: WagonMap,
  candidateLink: CandidateLink,
  candidatePlate: CandidatePlate,
  candidateRefusalInfo: RefusalPlateInfo,
  candidateActions: AttendanceActions,
  candidateFooter: OtherAttendance,
};
export default {
  availableList: AvailableList,
  attendedList: TravelStageList,
  inTransitList: TravelStageList,
  atDestinationList: TravelStageList,
  trips: OpenTripsList,
  vehicles: CandidateModal,
  filters: FilterModal,
};
